/** One-shot values for the seller's "Create listing draft" form (e.g. from an
 * AI agent suggestion). The seller still reviews and submits the form. */
type Values = Record<string, string>;
let pending: Values | undefined;
const listeners = new Set<() => void>();
export function setDraftPrefill(values: Values) { pending = values; for (const l of listeners) l(); }
export function takeDraftPrefill() { const v = pending; pending = undefined; return v; }
export function onDraftPrefill(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener); }; }
